import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { ButtonComponent, PopupButton } from 'ui-component/src/public-api';

export interface IDashboardTutorialDialog {
  title: string;
  subTitle?: string;
  illustration?: string;
  illustrationPosition?: string | 'top' | 'bottom';
  buttonOrientation: 'Horizontal Buttons' | 'Vertical Buttons';
  buttons: IDashboardTutorialButton;
}

export interface IDashboardTutorialButton {
  primary: PopupButton;
  secondary?: PopupButton;
}

@Component({
  selector: 'app-dashboard-tutorial-dialog',
  templateUrl: './dashboard-tutorial-dialog.component.html',
  styleUrls: ['./dashboard-tutorial-dialog.component.scss'],
  standalone: true,
  imports: [CommonModule, ButtonModule, ButtonComponent],
})
export class DashboardTutorialDialogComponent implements OnInit {
  data: IDashboardTutorialDialog;

  constructor(
    public cfg: DynamicDialogConfig<IDashboardTutorialDialog>,
    private ref: DynamicDialogRef
  ) {
    this.data = cfg.data!;
  }

  ngOnInit(): void {}
}
